(function () {
  const TOGGLE_URL = '/apps/designer-favorites/toggle';
  const SYNC_URL = '/apps/designer-favorites/sync';
  const LEGACY_KEY = 'designer_collection_favorites';

  function readInitialFavorites() {
    if (Array.isArray(window.__designerFavoriteHandles)) {
      return window.__designerFavoriteHandles.slice();
    }
    return [];
  }

  function normalizeCollectionId(value) {
    if (value == null || value === '') return '';
    var text = String(value);
    var gid = text.match(/Collection\/(\d+)/);
    if (gid) return gid[1];
    return /^\d+$/.test(text) ? text : '';
  }

  function readIdList(raw) {
    var found = [];
    var seen = Object.create(null);

    function add(value) {
      var id = normalizeCollectionId(value);
      if (!id || seen[id]) return;
      seen[id] = true;
      found.push(id);
    }

    function walk(value) {
      if (value == null) return;
      if (typeof value === 'number') {
        add(value);
        return;
      }
      if (typeof value === 'string') {
        var matches = value.match(/Collection\/(\d+)/g);
        if (matches) {
          matches.forEach(add);
          return;
        }
        var trimmed = value.trim();
        if (!trimmed) return;
        try {
          var parsed = JSON.parse(trimmed);
          if (parsed !== value) walk(parsed);
        } catch (e) {}
        return;
      }
      if (Array.isArray(value)) {
        value.forEach(walk);
        return;
      }
      if (typeof value === 'object') {
        if (value.id != null) add(value.id);
        if (value.admin_graphql_api_id) add(value.admin_graphql_api_id);
        if (value.value != null) walk(value.value);
      }
    }

    walk(raw);
    return found;
  }

  function uniqueHandles(list) {
    var next = [];
    (Array.isArray(list) ? list : []).forEach(function (handle) {
      if (!handle || next.indexOf(handle) !== -1) return;
      next.push(handle);
    });
    return next;
  }

  if (window.DesignerFavorites && typeof window.DesignerFavorites.mergeBootstrap === 'function') {
    window.DesignerFavorites.mergeBootstrap();
    return;
  }

  // Last confirmed server list. Pending clicks overlay on top until each save finishes.
  let serverFavorites = uniqueHandles(readInitialFavorites());
  let favoriteIds = readIdList(window.__designerFavoriteIds);
  let pendingIntent = Object.create(null);
  let favoritesCache = serverFavorites.slice();
  let syncPromise = null;
  let toggleQueue = Promise.resolve();
  let mutationVersion = 0;

  function computeFavorites() {
    var list = serverFavorites.slice();
    Object.keys(pendingIntent).forEach(function (handle) {
      var want = pendingIntent[handle];
      var has = list.indexOf(handle) !== -1;
      if (want && !has) list.push(handle);
      if (!want && has) {
        list = list.filter(function (item) {
          return item !== handle;
        });
      }
    });
    return list;
  }

  function publish() {
    favoritesCache = computeFavorites();
    window.__designerFavoriteHandles = favoritesCache.slice();
    document.dispatchEvent(
      new CustomEvent('designerFavorites:changed', {
        detail: { favorites: favoritesCache.slice() },
      })
    );
  }

  function setFavorites(favorites) {
    serverFavorites = uniqueHandles(favorites);
    favoriteIds = [];
    publish();
  }

  function mergeBootstrap() {
    var handles = uniqueHandles(serverFavorites.concat(readInitialFavorites()));
    var ids = favoriteIds.slice();
    readIdList(window.__designerFavoriteIds).forEach(function (id) {
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    if (handles.length === serverFavorites.length && ids.length === favoriteIds.length) return;
    serverFavorites = handles;
    favoriteIds = ids;
    publish();
  }

  function absorbFavoriteIds(container) {
    if (!favoriteIds.length || !container) return;
    var changed = false;
    container.querySelectorAll('[data-favorite-btn], [data-designer-favorite-btn]').forEach(function (button) {
      var id = normalizeCollectionId(button.getAttribute('data-collection-id'));
      var handle = button.getAttribute('data-vendor');
      if (!id || !handle) return;
      var idIndex = favoriteIds.indexOf(id);
      if (idIndex === -1) return;
      favoriteIds.splice(idIndex, 1);
      if (serverFavorites.indexOf(handle) === -1) {
        serverFavorites.push(handle);
        changed = true;
      }
    });
    if (changed) publish();
  }

  function getFavorites() {
    return favoritesCache.slice();
  }

  function isFavorited(handle) {
    return favoritesCache.indexOf(handle) !== -1;
  }

  function toggle(collectionHandle, intendedFavorited) {
    var nextFavorited =
      typeof intendedFavorited === 'boolean'
        ? intendedFavorited
        : !isFavorited(collectionHandle);

    mutationVersion += 1;
    pendingIntent[collectionHandle] = nextFavorited;
    publish();

    var intended = nextFavorited;

    var job = function () {
      return (async function () {
        var previous = serverFavorites.slice();

        if (previous.indexOf(collectionHandle) !== -1 === intended) {
          if (pendingIntent[collectionHandle] === intended) {
            delete pendingIntent[collectionHandle];
          }
          publish();
          return { favorited: intended, favorites: previous.slice() };
        }

        try {
          var response = await fetch(TOGGLE_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
              collection_handle: collectionHandle,
              favorites: previous,
            }),
          });

          var raw = await response.text();
          var data = {};

          if (raw) {
            try {
              data = JSON.parse(raw);
            } catch (e) {
              throw new Error(raw.slice(0, 180) || 'Could not update favorites.');
            }
          }

          if (!response.ok) {
            throw new Error(data.error || 'Could not update favorites');
          }

          if (Array.isArray(data.favorites)) {
            serverFavorites = uniqueHandles(data.favorites);
          } else if (intended) {
            if (serverFavorites.indexOf(collectionHandle) === -1) {
              serverFavorites = serverFavorites.concat([collectionHandle]);
            }
          } else {
            serverFavorites = serverFavorites.filter(function (handle) {
              return handle !== collectionHandle;
            });
          }

          if (pendingIntent[collectionHandle] === intended) {
            delete pendingIntent[collectionHandle];
          }

          publish();
          data.favorited = isFavorited(collectionHandle);
          return data;
        } catch (error) {
          if (pendingIntent[collectionHandle] === intended) {
            delete pendingIntent[collectionHandle];
          }
          publish();
          throw error;
        }
      })();
    };

    var result = toggleQueue.then(job, job);
    toggleQueue = result.then(
      function () {},
      function () {}
    );
    return result;
  }

  async function syncLegacyLocalStorage() {
    if (syncPromise) return syncPromise;

    var started = mutationVersion;

    syncPromise = (async function () {
      try {
        const legacy = JSON.parse(localStorage.getItem(LEGACY_KEY));
        if (!Array.isArray(legacy) || legacy.length === 0) return;

        const response = await fetch(SYNC_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ handles: legacy }),
        });

        if (!response.ok) return;

        const data = await response.json();
        localStorage.removeItem(LEGACY_KEY);
        if (started !== mutationVersion) return;
        if (Array.isArray(data.favorites)) {
          setFavorites(data.favorites);
        }
      } catch (e) {
        // Ignore migration failures; server state remains source of truth.
      }
    })();

    return syncPromise;
  }

  function setButtonState(button, favorited) {
    button.classList.toggle('is-favorited', favorited);
    button.setAttribute('aria-pressed', favorited ? 'true' : 'false');

    const defaultLabel = button.dataset.designerFavoriteLabelDefault;
    const addedLabel = button.dataset.designerFavoriteLabelAdded;
    const labelEl = button.querySelector('[data-designer-favorite-label]');

    if (labelEl && defaultLabel && addedLabel) {
      const activeLabel = favorited ? addedLabel : defaultLabel;
      labelEl.textContent = activeLabel;

      const collectionTitle = button.dataset.collectionTitle;
      if (collectionTitle) {
        button.setAttribute('aria-label', activeLabel + ': ' + collectionTitle);
      }
    }
  }

  function applyToButtons(container, buttonSelector, handleAttribute) {
    if (!container) return;
    absorbFavoriteIds(container);
    const favorites = getFavorites();
    container.querySelectorAll(buttonSelector).forEach(function (button) {
      const handle = button.getAttribute(handleAttribute);
      setButtonState(button, favorites.indexOf(handle) !== -1);
    });
  }

  function applyHandleToAllButtons(handle, favorited, buttonSelector, handleAttribute, root) {
    (root || document).querySelectorAll(buttonSelector).forEach(function (button) {
      if (button.getAttribute(handleAttribute) === handle) {
        setButtonState(button, favorited);
      }
    });
  }

  window.DesignerFavorites = {
    getFavorites: getFavorites,
    isFavorited: isFavorited,
    toggle: toggle,
    syncLegacyLocalStorage: syncLegacyLocalStorage,
    setButtonState: setButtonState,
    applyToButtons: applyToButtons,
    applyHandleToAllButtons: applyHandleToAllButtons,
    mergeBootstrap: mergeBootstrap,
  };
})();
